import { render, staticRenderFns } from "./PaymentsConfigurationList.vue?vue&type=template&id=e4b30266&"
import script from "./PaymentsConfigurationList.vue?vue&type=script&lang=js&"
export * from "./PaymentsConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports